import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleDots = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			fill: "#EDEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			stroke: "#AC94FA",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9997 13.875C11.22 13.875 10.582 13.2926 10.582 12.5809V12.4191C10.582 11.7074 11.22 11.125 11.9997 11.125C12.7794 11.125 13.4174 11.7074 13.4174 12.4191V12.5809C13.4174 13.2926 12.7794 13.875 11.9997 13.875Z",
			fill: "#5521B5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5822 13.875C15.8025 13.875 15.1646 13.2926 15.1646 12.5809V12.4191C15.1646 11.7074 15.8025 11.125 16.5822 11.125C17.3619 11.125 17.9999 11.7074 17.9999 12.4191V12.5809C17.9999 13.2926 17.3619 13.875 16.5822 13.875Z",
			fill: "#5521B5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.41766 13.875C6.63795 13.875 6 13.2926 6 12.5809V12.4191C6 11.7074 6.63795 11.125 7.41766 11.125C8.19738 11.125 8.83532 11.7074 8.83532 12.4191V12.5809C8.83532 13.2926 8.19738 13.875 7.41766 13.875Z",
			fill: "#5521B5"
		})
	]
});
export default SvgCircleDots;
